import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import anime from 'animejs';
import store from './store'

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$anime', {value: anime});
Object.defineProperty(Vue.prototype, '$mobile', {value: window.innerWidth < 733});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
